import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import PromoCheckoutBanner from '../promoComponents/PromoCheckoutBanner';

import PromoCodeSection from './PromoCodeSection';
import { PaymentMethods } from './AccountUtils';
import FeeMessage from './FeeMessage';
import MembershipHeader from './MembershipHeader';
import PackageOptions from './PackageOptions';


const MembershipForm = (props) => {
  const {
    isCampaignActive,
    isMembershipPaymentPage,
    anchorToSubscribe,
    isGift,
    isItem,
    showPromoInput,
    shouldShowPromoCheckoutBanner,
    activeCampaign,
    campaignClassName,
    programs,
    activeProgram,
    handlePackageChange,
    mrSkinCampaign,
    displayTimeUnit,
    fetchPackages,
    listOfActiveCampaigns,
    setPromoCodeInfo,
    selectedPaymentMethod,
    epochAvailable,
    paysafeAvailable,
    onSubmitClick,
    calculateRecurringAmmount,
    ASNCampaign,
    oneClickPaymentData,
    onPaymentMethodChange,
    shouldAnimate,
    setAnimationState,
    isFanzoneSubscriptionPage,
    renderFeeMessage,
    hasPromoInURL,
    isPromoPage,
    promoCodeInfo,
    oldPrices,
  } = props;

  const buttonIsDisabled = !((activeProgram.id && selectedPaymentMethod) || !epochAvailable || !paysafeAvailable);

  const buttonText = useMemo(() => {
    if (isMembershipPaymentPage) {
      return (
        <React.Fragment>
          <h2>GET YOUR MEMBERSHIP NOW</h2>
        </React.Fragment>
      );
    }

    return 'CONTINUE';
  }, [isMembershipPaymentPage]);

  const shouldRenderComponent = !isGift && !isItem && !anchorToSubscribe;

  if (!shouldRenderComponent) {
    return null;
  }

  return (
    <form
      action="/account/submission"
      id="package_selection_form"
      method="GET"
    >
      <div id="package_selection_zone">
        <div>
          <PromoCheckoutBanner
            anchorToSubscribe={anchorToSubscribe}
            checkoutImage={activeCampaign.checkoutImage}
            shouldShowPromoCheckoutBanner={shouldShowPromoCheckoutBanner}
            showPromoInput={!showPromoInput}
          />
          <h3
            className={classnames({
              'caps': true,
              'mr-skin-header': mrSkinCampaign,
            })}
            style={{
              fontWeight: 600,
              marginBottom: '30px',
              marginTop: '60px',
            }}
          >
            <MembershipHeader
              isCampaignActive={isCampaignActive}
              isMembershipPaymentPage={isMembershipPaymentPage}
              mrSkinCampaign={mrSkinCampaign}
            />
          </h3>
          <div className="mapped-packages">
            <PackageOptions
              activeCampaign={activeCampaign}
              activeProgram={activeProgram}
              calculateRecurringAmmount={calculateRecurringAmmount}
              displayTimeUnit={displayTimeUnit}
              handlePackageChange={handlePackageChange}
              hasPromoInURL={hasPromoInURL}
              isPromoPage={isPromoPage}
              mrSkinCampaign={mrSkinCampaign}
              oldPrices={oldPrices}
              programs={programs}
              promoCodeInfo={promoCodeInfo}
              shouldAnimate={shouldAnimate}
            />
            <FeeMessage
              shouldRenderFeeMessage={renderFeeMessage}
            />
            <p className="small-font text-secondary fee-message">
              By signing up, you agree to our <a href="/terms_of_service">Terms of Service</a> and <a href="/privacy_policy">Privacy Policy</a>
            </p>
            {mrSkinCampaign && !ASNCampaign && (
              <span className="nnlivemrsk">
                Also includes 7 days FREE access to Naked News
                Live with your purchase!
              </span>
            )}
            <div id="payment-options-wrapper">
              <PaymentMethods
                epochAvailable={epochAvailable}
                oneClickPaymentData={oneClickPaymentData}
                paysafeAvailable={paysafeAvailable}
                selectedPaymentMethod={selectedPaymentMethod}
                onPaymentMethodChange={onPaymentMethodChange}
              />
            </div>
          </div>
        </div>
      </div>
      <PromoCheckoutBanner
        checkoutImage={activeCampaign.checkoutImage}
        shouldShowPromoCheckoutBanner={shouldShowPromoCheckoutBanner}
        showPromoInput={showPromoInput}
      />
      <PromoCodeSection
        fetchPackages={fetchPackages}
        isFanzoneSubscriptionPage={isFanzoneSubscriptionPage}
        listOfActiveCampaigns={listOfActiveCampaigns}
        setAnimationState={setAnimationState}
        setPromoCodeInfo={setPromoCodeInfo}
        showPromoInput={showPromoInput}
      />
      <div className="cta-button-container">
        <button
          className={`btn btn-primary btn-xxl btn-block montserrat caps continue-button ${campaignClassName}`}
          disabled={buttonIsDisabled}
          type="submit"
          onClick={onSubmitClick}
        >
          {buttonText}
        </button>
      </div>
    </form>
  );
};

MembershipForm.defaultProps = {
  showPromoInput: false,
  shouldShowPromoCheckoutBanner: false,
  activeCampaign: {},
  campaignClassName: '',
  isCampaignActive: false,
  programs: [],
  activeProgram: {},
  mrSkinCampaign: false,
  listOfActiveCampaigns: [],
  selectedPaymentMethod: 'CC',
  epochAvailable: false,
  paysafeAvailable: [],
  ASNCampaign: false,
};

export default MembershipForm;
